import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import type { membershipApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

// Mock per la configurazione self-registration
export const userSelfRegistrationConfiguration = http.get<object, object, membershipApi.UserSelfRegistrationConfig>(
  apiBaseUrl + '/users/self-registration-configuration',
  () => {
    const config: membershipApi.UserSelfRegistrationConfig = {
      privacyPolicyUrl: 'https://companywelfaresvil.poste.it/static/documents/privacy/Informativa_Privacy_Self_Registration.pdf',
    }
    return HttpResponse.json(config, { status: 200 })
  },
)
